import { EMPTY_TAX_MAPPING_MODEL } from "presentation/model/TaxMapping/TaxMappingModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: TaxMappingProvider,
    useTracked: useTaxMappingTracked
} = createContainer(() => useState(EMPTY_TAX_MAPPING_MODEL), {concurrentMode: true});
export { TaxMappingProvider, useTaxMappingTracked };
